import React from 'react';
import { Brain, Zap, ShieldAlert, List } from 'lucide-react';

export const SnapIVReportUI = ({ data, meta }) => {
  const s = data.scores || {};
  const isRedAlarm = data.summary?.includes("KIRMIZI");

  const getStatus = (critical, threshold) => {
    if (critical >= threshold) return { l: "KLİNİK DÜZEYDE (RİSKLİ)", c: "text-red-700", bg: "bg-red-500", p: 90 };
    if (critical >= threshold - 2) return { l: "SINIRDA (TAKİP GEREKLİ)", c: "text-amber-600", bg: "bg-amber-400", p: 60 };
    return { l: "NORMAL SEVİYE", c: "text-emerald-700", bg: "bg-emerald-500", p: 25 };
  };

  const inatt = getStatus(s.inattention?.critical, s.inattention?.threshold);
  const hyp = getStatus(s.hyperactivity?.critical, s.hyperactivity?.threshold);
  const odd = getStatus(s.odd?.critical, s.odd?.threshold);

  return (
    <div className="space-y-6 print:space-y-5 font-sans">
      {/* HEADER */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div>
          <h2 className="text-xl print:text-lg font-bold leading-none mb-1">SNAP-IV Klinik Analiz Raporu</h2>
          <span className="text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">{meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}</span>
        </div>
        <div className="bg-white/10 px-4 py-2 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl font-black block leading-none">{data.risks?.length || 0}</span>
          <span className="text-[9px] block opacity-70 uppercase font-bold">Kritik Madde</span>
        </div>
      </div>

      {/* BAROMETRELER */}
      <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-6 print:gap-4">
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
             <div className="flex items-center mb-3 border-b border-slate-100 pb-2"><Brain className="h-5 w-5 text-indigo-500 mr-2"/><div><span className="text-sm font-black text-slate-800 uppercase tracking-widest block">DİKKAT EKSİKLİĞİ</span></div></div>
             <div className="flex justify-between mb-2"><span className={`text-sm font-black ${inatt.c}`}>{inatt.l}</span><span className="text-xs font-bold text-slate-400">{s.inattention?.critical}/9 Semptom</span></div>
             <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1"><div className={`h-full ${inatt.bg}`} style={{ width: `${inatt.p}%` }}></div></div>
             <p className="text-[9px] text-slate-400 text-right">(Klinik Eşik: {s.inattention?.threshold} Semptom)</p>
         </div>
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
             <div className="flex items-center mb-3 border-b border-slate-100 pb-2"><Zap className="h-5 w-5 text-amber-500 mr-2"/><div><span className="text-sm font-black text-slate-800 uppercase tracking-widest block">HİPERAKTİVİTE</span></div></div>
             <div className="flex justify-between mb-2"><span className={`text-sm font-black ${hyp.c}`}>{hyp.l}</span><span className="text-xs font-bold text-slate-400">{s.hyperactivity?.critical}/9 Semptom</span></div>
             <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1"><div className={`h-full ${hyp.bg}`} style={{ width: `${hyp.p}%` }}></div></div>
             <p className="text-[9px] text-slate-400 text-right">(Klinik Eşik: {s.hyperactivity?.threshold} Semptom)</p>
         </div>
         <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
             <div className="flex items-center mb-3 border-b border-slate-100 pb-2"><ShieldAlert className="h-5 w-5 text-rose-500 mr-2"/><div><span className="text-sm font-black text-slate-800 uppercase tracking-widest block">KARŞIT GELME (ODD)</span></div></div>
             <div className="flex justify-between mb-2"><span className={`text-sm font-black ${odd.c}`}>{odd.l}</span><span className="text-xs font-bold text-slate-400">{s.odd?.critical}/8 Semptom</span></div>
             <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-1"><div className={`h-full ${odd.bg}`} style={{ width: `${odd.p}%` }}></div></div>
             <p className="text-[9px] text-slate-400 text-right">(Klinik Eşik: {s.odd?.threshold} Semptom)</p>
         </div>
      </div>

      {/* RİSKLİ MADDELER LİSTESİ */}
      <div className="bg-slate-50 p-5 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none flex-1">
        <h3 className="font-bold text-slate-800 mb-4 flex items-center text-sm border-b pb-3">
          <List className="h-4 w-4 mr-2 text-slate-500"/> Semptom Gösterilen Kritik Maddeler ({data.risks?.length || 0})
        </h3>
        {data.risks?.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {data.risks.map((item, i) => (
              <div key={i} className="flex items-start p-3 bg-white border border-red-200 rounded-xl shadow-sm">
                <div className="min-w-[24px] h-6 rounded flex items-center justify-center text-[10px] font-black mr-3 bg-red-100 text-red-700 border-red-200">{item.id}</div>
                <div className="flex-1">
                  <div className="flex justify-between items-center mb-1">
                    <span className="block text-[8px] font-bold text-slate-400 uppercase tracking-wider">{item.category}</span>
                    <span className="text-[8px] px-1.5 py-0.5 bg-red-100 text-red-700 rounded font-black tracking-widest uppercase">
                       {item.score === 3 ? "FAZLASIYLA" : "OLDUKÇA"}
                    </span>
                  </div>
                  <span className="text-[11px] text-slate-800 font-medium block">{item.text}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-slate-400 italic text-center py-4">Klinik sınırda işaretlenmiş madde bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
};